import { Injectable } from '@angular/core';

import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VentoutwallService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  getVentOutWallList(page, size, payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/wall/get-wall?offset=${page}&limit=${size}`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }

  deleteVentOutWall(payload): Observable<any> {
    return this.http.get(`${this.baseUrl}/wall/delete-wall/${payload}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }

  updateVent(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/wall/update-vent`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }


  addCategory(payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/wall/add-wall-cat`,payload)
      .pipe(map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }

  deleteCategory(payload): Observable<any> {
    return this.http.get(`${this.baseUrl}/wall/delete-wall-cat/${payload}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }

  getCategoriesList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/wall/get-wall-cat`).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }

  editCategory(payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/wall/edit-wall-cat`,payload)
      .pipe(map((res) => {
          return res;
        }),
        catchError(VentoutwallService.handleError));
  }


  addWallReply(payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/wall/add-wall-reply`,payload)
      .pipe(map((res) => {
          return res;
        }),
        catchError(VentoutwallService.handleError));
  }

  addWall(payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/wall/add-wall`,payload)
      .pipe(map((res) => {
          return res;
        }),
        catchError(VentoutwallService.handleError));
  }
  
  getWallReply(payload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/wall/get-wall-reply`,payload)
      .pipe(map((res) => {
          return res;
        }),
        catchError(VentoutwallService.handleError));
  }

  deleteWallReply(payload): Observable<any> {
    return this.http.get(`${this.baseUrl}/wall/delete-wall-reply/${payload}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(VentoutwallService.handleError));
  }
}
